<template>
    <tr class="entity-row-cs-36" v-if="!isDeleted">
        <td>

            <router-link :to="{ name: 'extinguisher-report-view-extinguisher', params: {id: extinguisher.site_extinguisher_report_item_id} }" class="d-block">
                {{ extinguisher.extinguisher_identifier }} | {{ extinguisher.extinguisher_location }} </router-link>
        </td>
        <td>
            <router-link :to="{ name: 'extinguisher-report-view-extinguisher', params: {id: extinguisher.site_extinguisher_report_item_id} }" class="a-primary d-block">
                View </router-link>
        </td>
        <td>
            <router-link :to="{ name: 'extinguisher-report-edit-extinguisher', params: {id: extinguisher.site_extinguisher_report_item_id} }"  class="a-info d-block">Edit</router-link>
        </td>
        <td>
            <a class="a-positive d-block"
               v-bind:href="'#clone-extinguisher-link-' + extinguisher.site_extinguisher_report_item_id"
               v-bind:id="'clone-extinguisher-link-' + extinguisher.site_extinguisher_report_item_id"
               v-on:click="cloneExtinguisher"
               v-bind:data-extinguisher-id="extinguisher.site_extinguisher_report_item_id"
               ref="cloneButton"
            >
                Clone</a>
        </td>
        <td>
            <a class="a-danger delete-entity d-block"
               v-bind:href="'#delete-extinguisher-link-' + extinguisher.site_extinguisher_report_item_id"
               v-bind:id="'delete-extinguisher-link-' + extinguisher.site_extinguisher_report_item_id"
               v-on:click="deleteExtinguisher"
               v-bind:data-extinguisher-id="extinguisher.site_extinguisher_report_item_id"
               ref="deleteButton"
            >Delete</a>
        </td>
    </tr>
</template>
<script>
    export default {
        props: ['extinguisher'],
        data() {
            return {
                isDeleted: false,
                extinguisherToDelete: null,
                extinguisherToClone: null,
            }
        },
        methods: {
            deleteExtinguisher() {
                var button = this.$refs.deleteButton;
                var itemId = button.dataset.extinguisherId;

                if (!window.indexedDB) {
                    window.alert("Your browser doesn't support a stable version of IndexedDB.")
                }

                var db;
                var dbName = this.getCmsDetails('dbname');
                var request = window.indexedDB.open(dbName, this.dbVersionNumber);

                request.onerror = function (event) {
                    console.log("error: ");
                };

                var vmt = this;
                request.onsuccess = function (event) {
                    db = request.result;

                    var vm = vmt;
                    try {
                        var extinguisherId = parseInt(itemId);
                        var objectStore = db.transaction('extinguisher_report_items').objectStore('extinguisher_report_items');
                        var storeRequest = objectStore.get(extinguisherId);

                        storeRequest.onsuccess = function(event) {
                            vm.extinguisherToDelete = storeRequest.result;
                            vm.extinguisherToDelete.is_deleted = true;

                            vm.$swal({
                                title: 'Are you sure?',
                                text: 'Are you sure you want to delete this extinguisher?',
                                type: 'warning',
                                showCancelButton: true,
                                confirmButtonColor: '#DD6B55',
                                confirmButtonText: 'Yes',
                                closeOnConfirm: false,
                                showLoaderOnConfirm: true,
                                buttons: {
                                    cancel: {
                                        text: 'Cancel',
                                        value: null,
                                        visible: false,
                                        className: 'btn btn-square btn-sm btn-secondary',
                                        closeModal: true,
                                    },
                                    confirm: {
                                        text: 'Yes',
                                        value: true,
                                        visible: true,
                                        className: 'btn btn-square btn-sm btn-primary',
                                        closeModal: true
                                    }
                                }
                            }).then((result) => {
                                if (result.value) {
                                    var putRequest = db.transaction('extinguisher_report_items', 'readwrite')
                                        .objectStore('extinguisher_report_items').put(vm.extinguisherToDelete);
                                    putRequest.onsuccess = function(event) {
                                        vm.isDeleted = true;
                                    };
                                    putRequest.onerror = function(event) {
                                        console.log(event);
                                    };
                                }
                            });
                        };
                        storeRequest.onerror = function(e) {
                            console.log(e)
                        }
                    } catch(e) {
                        console.log(e);
                    }
                };

                request.onupgradeneeded = function (event) {
                    var db = event.target.result;
                };
            },
            cloneExtinguisher() {
                var button = this.$refs.deleteButton;
                var itemId = button.dataset.extinguisherId;

                if (!window.indexedDB) {
                    window.alert("Your browser doesn't support a stable version of IndexedDB.")
                }

                var db;
                var dbName = this.getCmsDetails('dbname');
                var request = window.indexedDB.open(dbName, this.dbVersionNumber);

                request.onerror = function (event) {
                    console.log("error: ");
                };

                var vmt = this;
                request.onsuccess = function (event) {
                    db = request.result;

                    var vm = vmt;
                    try {
                        var extinguisherId = parseInt(itemId);
                        var objectStore = db.transaction('extinguisher_report_items').objectStore('extinguisher_report_items');
                        var storeRequest = objectStore.get(extinguisherId);

                        storeRequest.onsuccess = function(event) {
                            vm.extinguisherToClone = storeRequest.result;
                            vm.extinguisherToClone.extinguisher_identifier = storeRequest.result.extinguisher_identifier + ' (clone)';
                            vm.extinguisherToClone.extinguisher_image = null;
                            vm.extinguisherToClone.extinguisher_offline_image = null;
                            vm.extinguisherToClone.site_extinguisher_report_item_id = Math.floor(new Date().getTime() / 1000);

                            vm.$swal({
                                title: 'Are you sure?',
                                text: 'Are you sure you want to clone this extinguisher?',
                                type: 'info',
                                showCancelButton: true,
                                confirmButtonColor: '#DD6B55',
                                confirmButtonText: 'Yes',
                                closeOnConfirm: false,
                                showLoaderOnConfirm: true,
                                buttons: {
                                    cancel: {
                                        text: 'Cancel',
                                        value: null,
                                        visible: false,
                                        className: 'btn btn-square btn-sm btn-secondary',
                                        closeModal: true,
                                    },
                                    confirm: {
                                        text: 'Yes',
                                        value: true,
                                        visible: true,
                                        className: 'btn btn-square btn-sm btn-primary',
                                        closeModal: true
                                    }
                                }
                            }).then((result) => {
                                if (result.value) {
                                    var putRequest = db.transaction('extinguisher_report_items', 'readwrite')
                                        .objectStore('extinguisher_report_items').put(vm.extinguisherToClone);
                                    putRequest.onsuccess = function(event) {
                                       vm.reload();
                                    };
                                    putRequest.onerror = function(event) {
                                        console.log(event);
                                    };
                                }
                            });
                        };
                        storeRequest.onerror = function(e) {
                            console.log(e)
                        }
                    } catch(e) {
                        console.log(e);
                    }
                };

                request.onupgradeneeded = function (event) {
                    var db = event.target.result;
                };


            },
            reload() {
                window.location = '';
            }
        }
    }
</script>